export const decemberUppercase = "$qa";
export default {decemberUppercase};